"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVITE_INVALID = exports.LOGIN_CHANGE_MODE_TAB = exports.WORKBENCH_PAGE = exports.LOGIN_BTN = exports.IDENTIFYING_CODE_INPUT = exports.GET_IDENTIFYING_CODE_BTN = exports.LOGIN_MAIL_INPUT = exports.CHANGE_MODE_BTN = exports.LOGIN_PASSWORD_INPUT = exports.LOGIN_PHONE_INPUT = exports.TEMPLATE_DETAIL_CONTAINER = exports.SHARE_CONTAINER = exports.FORM_CONTAINER = exports.SHARE_MENU_CARD_BTN = exports.GO_LOGIN_BTN = exports.LOGIN = void 0;
/**
 * Do not touch, the ID in this file is for automated testing
 */
const PREFIX = 'VIKA_';
// Represents the login page
exports.LOGIN = PREFIX + 'LOGIN';
// "Go to login" button
exports.GO_LOGIN_BTN = PREFIX + 'GO_LOGIN_BTN';
// Share page - the button in the card below the menu on the left, such as "Save to my space"
exports.SHARE_MENU_CARD_BTN = PREFIX + 'SHARE_MENU_CARD_BTN';
// Magical form sharing page Container
exports.FORM_CONTAINER = PREFIX + 'FORM_CONTAINER';
// Share page Container
exports.SHARE_CONTAINER = PREFIX + 'SHARE_CONTAINER';
// Template details Container
exports.TEMPLATE_DETAIL_CONTAINER = PREFIX + 'TEMPLATE_DETAIL_CONTAINER';
// Login page - mobile phone number input box
exports.LOGIN_PHONE_INPUT = PREFIX + 'LOGIN_PHONE_INPUT';
// Login page - password input box
exports.LOGIN_PASSWORD_INPUT = PREFIX + 'LOGIN_PASSWORD_INPUT';
// Login - button to switch the login method
exports.CHANGE_MODE_BTN = PREFIX + 'CHANGE_MODE_BTN';
// Login page - email input box
exports.LOGIN_MAIL_INPUT = PREFIX + 'LOGIN_MAIL_INPUT';
// get verification code button
exports.GET_IDENTIFYING_CODE_BTN = PREFIX + 'GET_IDENTIFYING_CODE_BTN';
// verification code input box
exports.IDENTIFYING_CODE_INPUT = PREFIX + 'IDENTIFYING_CODE_INPUT';
// login button
exports.LOGIN_BTN = PREFIX + 'LOGIN_BTN';
// workbench page
exports.WORKBENCH_PAGE = PREFIX + 'WORKBENCH_PAGE';
// Login page - login switch Tab
exports.LOGIN_CHANGE_MODE_TAB = PREFIX + 'LOGIN_CHANGE_MODE_TAB';
// Invitation invalidation page
exports.INVITE_INVALID = PREFIX + 'INVITE_INVALID';
//# sourceMappingURL=auto_test_id.js.map